import styled from 'styled-components';
import { DeviceType, Orientation, Platform } from 'sofa-reborn-react';
import { SkapaTheme } from '@inter-ikea-kompis/themes';

export const ItemContainer = styled.div<{
	disabled: boolean;
}>`
	width: calc(100% - 16px);
	padding: 8px;
	display: flex;
	flex-direction: column;
	align-items: center;
	cursor: ${(props) => (props.disabled ? 'not-allowed' : 'grab')};
	border-radius: 2px;

	&.focus-visible {
		/* !important used here to overwrite default Skapa outline */
		box-shadow: 0 0 0 ${SkapaTheme.focusOutline.width}px ${SkapaTheme.focusOutline.color} !important;
	}
`;

export const ImageIconContainer = styled.div<{
	isDragged: boolean;
	platform: Platform;
	deviceType: DeviceType;
	orientation: Orientation;
	stockStatus: boolean;
	disabled: boolean;
}>`
	position: relative;

	[data-element-name='kompis-image'] {
		width: ${(props) =>
			props.platform === 'kiosk'
				? '120px'
				: props.deviceType === 'tablet' && props.stockStatus
				? '90px'
				: props.deviceType === 'mobile'
				? '80px'
				: '100px'};
		height: 100%;
		display: block;
		margin: auto;
		transition-property: transform;
		transition-duration: 200ms;
		transition-timing-function: cubic-bezier(0.4, 0, 0.4, 1);
		transform: scale(${(props) => (props.isDragged ? 1.5 : 1.0)});
		pointer-events: none;
		opacity: ${(props) => (props.disabled ? 0.5 : 1)};
	}
`;

export const InformationContainer = styled.div<{
	isKiosk: boolean;
	deviceType: DeviceType;
}>`
	margin: 0 0.5rem;
	display: flex;
	flex-direction: column;
	align-items: ${(props) => (props.isKiosk || props.deviceType === 'tablet' ? 'normal' : 'center')};
`;

export const TextContainer = styled.div<{
	disabled: boolean;
	isKiosk: boolean;
}>`
	width: ${(props) => (props.isKiosk ? '100%' : '80%')};
	text-align: center;

	[data-element-name='kompis-text'] {
		display: block;
		color: ${(props) =>
			props.disabled ? SkapaTheme.color.text.lightest : SkapaTheme.color.text.default};
	}
`;

export const StatusWrapper = styled.div<{
	disabled: boolean;
}>`
	opacity: ${(props) => (props.disabled ? 0.5 : 1)};
`;

export const ImageWrapper = styled.div<{
	isKiosk: boolean;
}>`
	width: ${(props) => (props.isKiosk ? '100%' : '100px')};
	height: ${(props) => (props.isKiosk ? 'auto' : '104px')};
`;
